<div class="advanced-search-container flex flex-column gap-150">
  <div class="flex-center-between">
    <span class="text-label-14 text-semibold">{{ data.title || 'Búsqueda avanzada de contenedores' }}</span>
    <button nz-button nzType="text" nzShape="circle" nzSize="default" (click)="close()">
      <app-st-icon name="close" [bold]="true"></app-st-icon>
    </button>
  </div>

  <div class="flex flex-column gap-050">
    <span class="text-label-12 color-grey-9">
      Pega una lista (línea, coma, punto y coma, tab o espacio). Se aplica trim, mayúsculas, deduplicación y validación de formato.
    </span>
    <span class="text-label-12 color-grey-9">
      La búsqueda se realiza por coincidencia exacta del número de contenedor.
    </span>
  </div>

  <textarea
    [(ngModel)]="searchInput"
    (ngModelChange)="onSearchInputChange($event)"
    nz-input
    rows="6"
    placeholder="Ejemplo:&#10;MSCU6639871&#10;TGHU1234560, FCIU4021453; TEMU7301255"></textarea>

  <div class="flex-center-between gap-100">
    <div class="flex-center gap-100">
      <button class="text-btn-14" nz-button nzType="primary" nzShape="round" (click)="runSearch()" [disabled]="loading">
        @if (loading) {
          <app-st-icon class="prefix" [bold]="true" name="progress_activity"></app-st-icon>
        }
        Buscar
      </button>
      <button class="text-btn-14" nz-button nzType="default" nzShape="round" (click)="requestClearAppliedFilter()" [disabled]="loading">
        Limpiar
      </button>
    </div>
    <button class="text-btn-14" nz-button nzType="default" nzShape="round" (click)="exportCsv()" [disabled]="rows.length === 0 || loading">
      Exportar CSV
    </button>
  </div>

  @if (searched) {
    <div class="flex flex-wrap gap-100 summary-row">
      <div class="st-badget subtle-grey"><label>Total: {{ summary.total }}</label></div>
      <div class="st-badget subtle-green"><label>Encontrados: {{ summary.found }}</label></div>
      <div class="st-badget subtle-amber"><label>No encontrados: {{ summary.notFound }}</label></div>
      <div class="st-badget subtle-red"><label>Inválidos: {{ summary.invalid }}</label></div>
    </div>
  }

  @if (rows.length > 0) {
    <div class="table-wrapper">
      <table class="st-table">
        <thead>
          <tr>
            <th>Número contenedor</th>
            <th>Clasificación</th>
            @if (data.section === 'containers') {
              <th>Tipo</th>
            } @else {
              <th>Orden asociada</th>
              <th>Estado actual</th>
              <th>Último evento / fecha</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (row of rows; track $index) {
            <tr>
              <td>{{ row.containerNumber }}</td>
              <td>{{ getClassificationLabel(row.classification) }}</td>
              @if (data.section === 'containers') {
                <td>{{ row.containerTypeCode ?? '-' }}</td>
              } @else {
                <td>{{ row.referenceOrder || '-' }}</td>
                <td>
                  <span style="line-height: 1.8"
                        [ngClass]="row.currentStatusClass || 'subtle-grey'"
                        class="st-badget text-semibold text-nowrap">
                    @if (row.currentStatusIcon) {
                      <app-st-icon [name]="row.currentStatusIcon" [bold]="true"></app-st-icon>
                    }
                    <label class="text-nowrap">{{ row.currentStatus || '-' }}</label>
                  </span>
                </td>
                <td>{{ row.lastEventDate || '-' }}</td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
  } @else if (searched && !loading) {
    <nz-empty nzNotFoundImage="simple" nzNotFoundContent="No hay resultados"></nz-empty>
  }

  <div class="flex-center-between">
    <span class="text-label-12 color-grey-9">Solo se aplicarán contenedores clasificados como Encontrado.</span>
    <button class="text-btn-14" nz-button nzType="primary" nzShape="round" [disabled]="!hasFoundRows || loading" (click)="applyFoundRows()">
      Aplicar encontrados
    </button>
  </div>
</div>
